import { render, staticRenderFns } from "./entity-info-card.vue?vue&type=template&id=e7ff532c&scoped=true"
import script from "./entity-info-card.vue?vue&type=script&lang=ts"
export * from "./entity-info-card.vue?vue&type=script&lang=ts"
import style0 from "./entity-info-card.vue?vue&type=style&index=0&id=e7ff532c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ff532c",
  null
  
)

export default component.exports